import { render, staticRenderFns } from "./IgPostElement.vue?vue&type=template&id=15304b80&scoped=true&"
import script from "./IgPostElement.vue?vue&type=script&lang=js&"
export * from "./IgPostElement.vue?vue&type=script&lang=js&"
import style0 from "./IgPostElement.vue?vue&type=style&index=0&id=15304b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15304b80",
  null
  
)

export default component.exports